import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink,
  from,
  ApolloLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import { onError } from "@apollo/client/link/error";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import "react-modern-drawer/dist/index.css";
import authStore from "stores/authStore";

const handleAuthError = () => {
  window.location.href = "/";
  // Clear any local auth state
  authStore.setIsAuthenticated(false);
};

const errorLink = onError(({ graphqlErrors }) => {
  if (graphqlErrors) {
    graphqlErrors.map(({ message }) => {
      alert(`Graphql error ${message}`);
    });
  }
});

const authResponseLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    // Check if the response data contains authentication errors
    const responseString = JSON.stringify(response);

    if (
      responseString.includes("You are not authenticated") ||
      responseString.includes("not authenticated") ||
      responseString.includes("token expired") ||
      responseString.includes("unauthorized")
    ) {
      console.log({ responseString });
      handleAuthError();
      // alert("Token Expired. Please Login user.");

      return response; // Still return the response
    }

    return response;
  });
});

const link = from([
  authResponseLink,
  errorLink,
  new HttpLink({
    uri: process.env.REACT_APP_GRAPHQL_URL,
    // uri: process.env.REACT_APP_GRAPHQL_STAGING_URL,
    credentials: "include",
    fetchOptions: {
      credentials: "include",
    },
  }),
]);

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: link,

  // link: authLink.concat(link),
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client} className="font-sans">
      <Router>
        <App />
      </Router>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);
